import React from 'react'
import { PricingPlans } from '../Pages/JobPostPricing/PricingPlans'

function Jobpostpricing() {
  return (
    <>
        <PricingPlans />
    </>
  )
}

export default Jobpostpricing
